import React from 'react'
import styled from 'styled-components'
import { fontWeight } from 'themes/font'
import { Row, Col } from 'reactstrap'
import { mentors } from '../data'
import { media } from 'styled-bootstrap-grid'

const Container = styled.div`
  margin-top: 30px;
  margin-bottom: -30px;
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 30px;
  transition: transform .4s;
  cursor: pointer;
  .avatar {
    width: 150px;
    margin-bottom: 16px;
  }
  .fullName {
    font-size: 1.25rem;
    font-weight: ${fontWeight.bold};
    margin-bottom: 4px;
  }
  ${media.md`
    &:hover {
      transform: translateY(-16px);
    }
  `}
`

const Mentors = () => {
  return (
    <Container className='wow fadeIn'>
      <Row>
        {mentors.map((mentor, index) => (
          <Col xs={12} lg={6} xl={4} key={index}>
            <Item>
              <img className='avatar' src={mentor.avatar} alt={mentor.fullName} />
              <div className='fullName'>{mentor.fullName}</div>
              <div className='position'>{mentor.position}</div>
            </Item>
          </Col>
        ))}
      </Row>
    </Container>
  )
}

export default Mentors
